export default {"src":"/_next/static/media/logo.15d024cb.svg","height":57,"width":335,"blurWidth":0,"blurHeight":0};